<div
  class="tw-text-white tw-w-full tw-rounded-[4px] tw-p-2 tw-whitespace-nowrap"
  data-cy="deal-status-display-current"
  [ngClass]="dealStageColorClassMap[deal.stage]"
  [matTooltip]="'Contact Funding Desk to change status'"
  [matTooltipDisabled]="!(canSeeDealStatusRestrictions$ | async) || !showTooltip"
>
  {{ statusFormatted }}
</div>
